import Home from './Home';
import Login from './Login';
import NotFound from './NotFound';
import ByDate from './ByDate';
import ByDayOfWeek from './ByDayOfWeek';
import ByHour from './ByHour';
import RefreshData from "./RefreshData";
import DeleteAccount from "./DeleteAccount";
import DgvClub from "./DgvClub";
import Opponents from './Opponents';
import Holes from './Holes';
import Admin from './Admin';
import UserProfile from './UserProfile';
import AdminDashboard from './AdminDashboard';
import AdminAddEvent from './AdminAddEvent';
import AdminEditEvent from './AdminEditEvent';
import AdminEventsList from './AdminEventsList';
import AdminSettings from './AdminSettings';
import AdminDatabaseQueries from './AdminDatabaseQueries';

interface RouteType {
    path: string;
    component: any;
    name: string;
    protected: boolean;
    clubOnly?: boolean;
    adminOnly?: boolean;
    creatorOnly?: boolean;
}

const routes: RouteType[] = [
    {
        path: '',
        component: Home,
        name: 'Summary',
        protected: true,
    },
    {
        path: '/period',
        component: ByDate,
        name: 'By Period',
        protected: true,
    },
    {
        path: '/period/daily',
        component: ByDayOfWeek,
        name: 'By Period: Daily',
        protected: true,
    },
    {
        path: '/period/hourly',
        component: ByHour,
        name: 'By Period: Hourly',
        protected: true,
    },
    {
        path: '/opponents',
        component: Opponents,
        name: 'Opponents',
        protected: true,
        clubOnly: true,
    },
    {
        path: '/holes',
        component: Holes,
        name: 'Holes',
        protected: true,
        clubOnly: true,
    },
    {
        path: '/login',
        component: Login,
        name: 'Login Screen',
        protected: false,
    },
    {
        path: "/deleteaccount",
        component: DeleteAccount,
        name: "Delete Account Screen",
        protected: true,
    },
    {
        path: "/refresh",
        component: RefreshData,
        name: "Refresh Data",
        protected: true,
    },
    {
        path: "/dgv_club",
        component: DgvClub,
        name: "DGV Club",
        protected: true,
    },
    {
        path: "/profile",
        component: UserProfile,
        name: "User Profile",
        protected: true,
    },
    {
        path: "/admin",
        component: Admin,
        name: "Admin Home",
        protected: true,
        adminOnly: true,
        creatorOnly: true,
    },
    {
        path: '/admin/dashboard',
        component: AdminDashboard,
        name: 'Admin Dashboard',
        protected: true,
        adminOnly: true,
        creatorOnly: true,
    },
    {
        path: '/admin/add-event',
        component: AdminAddEvent,
        name: 'Add Event',
        protected: true,
        adminOnly: true,
        creatorOnly: true,
    },
    {
        path: '/admin/edit-event/:eventID',
        component: AdminEditEvent,
        name: 'Edit Event',
        protected: true,
        adminOnly: true,
        creatorOnly: true,
    },
    {
        path: '/admin/events',
        component: AdminEventsList,
        name: 'Events',
        protected: true,
        adminOnly: true,
        creatorOnly: false,
    },
    {
        path: '/admin/settings',
        component: AdminSettings,
        name: 'Admin Settings',
        protected: true,
        adminOnly: true,
        creatorOnly: true,
    },
    {
        path: '/admin/database-queries',
        component: AdminDatabaseQueries,
        name: 'Database Queries',
        protected: true,
        adminOnly: true,
        creatorOnly: true,
    },
    {
        path: '*',
        component: NotFound,
        name: '404 Not Found',
        protected: false,
    }
];

export default routes;
